import { ISortTable } from "../../../utils/types";
import { SessionDeliveryOption } from "../../../utils/types/session";

export interface IEditCancellationNotePayload {
    reason: string;
    signature?: string;
}

export interface IEditFamilyIntakeNote {
    family: FamilyIntakeNotePayload[];
    signature?: string;
    appointment_location: string;
    isClientPresent?: boolean;
    diagnosis_codes: string[];
    secondary_diagnosis: string[];
    tertiary_diagnosis: string[];
    additional_diagnosis_one?: string[];
    additional_diagnosis_two?: string[];
    delivery_option: string;
    provider_location: string;
    other_provider_location?: string;
    other_delivery_option?: string;
    consent_was_received_for_the_teletherapy_session: boolean;
    the_teletherapy_session_was_conducted_via_video: boolean;
    duration: string;
    what_are_the_problem_you_are_seeking_help_for: string;
    people_present_at_session: string[];
    other_person_present_at_session: string;
    type_of_treatment_recommended: string[];
    treatment_modality_intervention: string[];
    other_treatment_modality_intervention: string;
    treatment_goal_one: string;
    treatment_goal_two: string;
    treatment_goal_three: string;
    frequency_of_sessions: string;
    other_frequency_of_sessions: string;
    date_of_next_session: string;
    subjective_report: string;
    summary: string;
    prognosis: string;
}

export interface IEditGeneralNotesPayload {
    update_note_content: string;
    signature?: string;
    diagnosis_codes: string[];
    secondary_diagnosis?: string[];
    tertiary_diagnosis?: string[];
    additional_diagnosis_one?: string[];
    additional_diagnosis_two?: string[];
    date_of_update: string;
}

export interface IEditPauseNotificationNote {
    pause_reason: string;
    signature?: string;
}

export interface IEditPauseNotificationPsychNotePayload {
    pause_reason: string;
    signature?: string;
}

export interface IEditNoShowPsychNotePayload {
    missed_appointment_type: string;
    no_show_reason: string;
    signature?: string;
}

export interface IEditCommunicationWithClientNotePayload {
    communication_details: string;
    signature?: string;
}

export interface IEditFormsAndDocumentationNotePayload {
    forms_and_documentation_details: string;
    signature?: string;
}

export interface IEditIndividualIntakeNote {
    appointment_location: string;
    diagnosis_codes: string[];
    secondary_diagnosis: string[];
    tertiary_diagnosis: string[];
    additional_diagnosis_one?: string[];
    additional_diagnosis_two?: string[];
    delivery_option: string;
    provider_location: string;
    other_provider_location?: string;
    consent_was_received_for_the_teletherapy_session: boolean;
    the_teletherapy_session_was_conducted_via_video: boolean;
    other_delivery_option?: string;
    duration: string;
    gender: string;
    other_gender: string;
    preferred_name: string;
    pronouns: string;
    other_sexual_orientation: string;
    religion: string;
    education: string;
    race: string;
    ethinicity: string;
    sexual_orientation: string;
    current_employment: string;
    current_employment_details: string;
    relationship_status: string;
    name_of_partner: string;
    emergency_contact_information: string;
    legal_problems: string;
    what_are_the_problem_you_are_seeking_help_for: string;
    anxiety_frequency: string;
    anxiety_details: string;
    panic_attacks_freqency: string;
    panic_attacks_details: string;
    depression_freqency: string;
    depression_details: string;
    selected_symptoms: string;
    other_symptoms: string[];
    physical_symptoms: string;
    medication_physical_psychiatric: string;
    sleeping_habits_and_concerns: string;
    difficulties_with_appetite_or_eating_patterns: string;
    parents_stepparents_history: string;
    siblings_history: string;
    grandparents_history: string;
    children_history: string;
    other_family_members_history: string;
    family_members_alcohol_abuse: string[];
    family_members_alcohol_abuse_other: string;
    family_members_anxiety: string[];
    family_members_anxiety_other: string;
    family_members_bipolar_disorder: string[];
    family_members_bipolar_disorder_other: string;
    family_members_depression: string[];
    family_members_depression_other: string;
    family_members_ptsd: string[];
    family_members_ptsd_other: string;
    family_members_schizophrenia: string[];
    family_members_schizophrenia_other: string;
    family_members_substance_abuse: string[];
    family_members_substance_abuse_other: string;
    family_members_substance_abuse_substance: string;
    trauma_abuse_history: string;
    previous_mental_health_treatment_oupatient: string;
    impatient_psychiatric_hospitalization: string;
    relevant_medical_history: string;
    been_so_distressed_you_seriously_wished_to_end_your_life: string;
    describe_been_so_distressed_you_seriously_wished_to_end_your_life?: string;
    has_anything_happened_recently_to_make_you_feel_you_dont_want_to_live: string;
    describe_has_anything_happened_recently_to_make_you_feel_you_dont_want_to_live?: string;
    a_specific_plan_of_how_you_would_kill_yourself: string;
    describe_a_specific_plan_of_how_you_would_kill_yourself?: string;
    access_to_weapons_or_means_of_hurting_self: string;
    describe_access_to_weapons_or_means_of_hurting_self?: string;
    made_serious_suicide_attempts: string;
    describe_made_serious_suicide_attempts?: string;
    purposely_done_something_to_hurt_yourself: string;
    describe_done_something_to_hurt_yourself?: string;
    heard_voices_telling_you_to_hurt_yourself: string;
    describe_heard_voices_telling_you_to_hurt_yourself?: string;
    had_relatives_who_attempted_or_commited_sucide: string;
    describe_had_relatives_who_attempted_or_commited_sucide?: string;
    had_thoughts_of_killing_or_seriously_hurting_someone: string;
    describe_had_thoughts_of_killing_or_seriously_hurting_someone?: string;
    heard_voices_telling_you_to_hurt_others: string;
    describe_heard_voices_telling_you_to_hurt_others?: string;
    hurt_someone_or_destroyed_property_on_purpose: string;
    describe_hurt_someone_or_destroyed_property_on_purpose?: string;
    slapped_kicked_punched_someone_with_intent_to_harm: string;
    describe_slapped_kicked_punched_someone_with_intent_to_harm?: string;
    been_arrested_or_detained_for_violent_behavior: string;
    describe_been_arrested_or_detained_for_violent_behavior?: string;
    been_to_jail_for_any_reason: string;
    describe_been_to_jail_for_any_reason?: string;
    been_on_probation_for_any_reason: string;
    describe_been_on_probation_for_any_reason?: string;
    do_you_have_access_to_guns: string;
    describe_do_you_have_access_to_guns?: string;
    mental_health_appearance: string[];
    mental_health_movement: string[];
    mental_health_speech_behaviour: string[];
    mental_health_affect_mood: string[];
    mental_health_attention_concentration_effort: string[];
    mental_health_presentation_of_self: string[];
    mental_health_cognition: string[];
    patients_ability_and_capability_to_respond_to_treatment: string[];
    details_for_diminished_poor_limited_quality_patient_oriented_evidence: string;
    people_present_at_session: string[];
    other_person_present_at_session: string;
    type_of_treatment_recommended: string[];
    treatment_modality_intervention: string[];
    other_treatment_modality_intervention: string;
    treatment_goal_one: string;
    treatment_goal_two: string;
    treatment_goal_three: string;
    frequency_of_sessions: string;
    other_frequency_of_sessions: string;
    date_of_next_session: string;
    subjective_report: string;
    summary: string;
    prognosis: string;
    contact_information_for_both_parents: string;
    name_address_of_personal_physician: string;
    date_of_last_exam: string;
    anxiety?: boolean;
    panic_attacks?: boolean;
    depression?: boolean;
    ever_run_away_from_home?: string;
    describe_ever_run_away_from_home?: string;
    ever_been_bullied_or_bullied_someone?: string;
    describe_ever_been_bullied_or_bullied_someone?: string;
    signature?: string;
}

export interface IEditRecordOfDisclosurePayload {
    duration: string;
    diagnosis_codes: string[];
    secondary_diagnosis?: string[];
    tertiary_diagnosis?: string[];
    additional_diagnosis_one?: string[];
    additional_diagnosis_two?: string[];
    disclosure_to_whom: string;
    disclosure_type: string;
    purpose_of_disclosure: string;
    type_disclosed: string;
    method_of_disclosure: string;
    record_of_disclosure_of_phi_ephi: string;
    consent_to_charge: boolean;
    signature?: string;
}

export interface IEditConsultationNoteMedPayload {
    session_location: string;
    prolonged_care_different_day_as_em_visit?: string[];
    details_of_prolonged_care_different_day_as_em_visit?: string;
    modality: string;
    total_amount_of_time?: string;
    condition_type: string;
    condition_type_additional_details?: string;
    condition_status: string;
    condition_status_additional_details?: string;
    signature?: string;
    location_of_the_client?: string;
    other_location_of_the_client?: string;
    location_of_the_provider?: string;
    other_location_of_the_provider?: string;
    consent_was_received_for_the_teletherapy_session?: boolean;
    the_session_was_conducted_via_video?: boolean;
}

export interface IEditDocumentationRequestNoteMedPayload {
    session_location: string;
    diagnosis_codes: string[];
    secondary_diagnosis?: string[];
    tertiary_diagnosis?: string[];
    additional_diagnosis_one?: string[];
    additional_diagnosis_two?: string[];
    record_of_disclosure_of_phi_ephi?: string | null;
    disclosure_to_whom: string;
    purpose_of_disclosure?: string | null;
    description_disclosure_purpose_of_disclosure?: string;
    type_disclosed?: string[] | null;
    how_disclosure_is_made?: string[] | null;
    other_how_disclosure_is_made?: string;
    start_time?: string | null;
    end_time?: string | null;
    files?: string;
    signature?: string;
    location_of_the_client?: string;
    other_location_of_the_client?: string;
    location_of_the_provider?: string;
    other_location_of_the_provider?: string;
    consent_was_received_for_the_teletherapy_session?: boolean;
    the_session_was_conducted_via_video?: boolean;
}

export interface IEditEvaluationSubmissionNoteMedPayload {
    session_location: string;
    date?: string | null;
    start_time?: string | null;
    end_time?: string | null;
    diagnosis_codes: string[];
    secondary_diagnosis?: string[];
    tertiary_diagnosis?: string[];
    additional_diagnosis_one?: string[];
    additional_diagnosis_two?: string[];
    files?: string;
    summary: string;
    name_of_provider_therapist?: string;
    signature?: string;
    location_of_the_client?: string;
    other_location_of_the_client?: string;
    location_of_the_provider?: string;
    other_location_of_the_provider?: string;
    consent_was_received_for_the_teletherapy_session?: boolean;
    the_session_was_conducted_via_video?: boolean;
}

export interface IEditNoShowNoteMedPayload {
    session_location: string;
    reason_provided_by_client_and_when_notice_was_given: string;
    signature?: string;
    location_of_the_client?: string;
    other_location_of_the_client?: string;
    location_of_the_provider?: string;
    other_location_of_the_provider?: string;
    consent_was_received_for_the_teletherapy_session?: boolean;
    the_session_was_conducted_via_video?: boolean;
}

export interface IEditTermOfCareNoteMedPayload {
    diagnosis_codes: string[];
    secondary_diagnosis?: string[];
    tertiary_diagnosis?: string[];
    additional_diagnosis_one?: string[];
    additional_diagnosis_two?: string[];
    files?: string;
    date_of_first_session: string;
    date_of_last_session: string;
    total_number_of_therapy_sessions: string;
    presenting_concerns: string;
    planned_treatment_and_goals: string;
    course_of_treatment: string;
    patient_final_condition: string[];
    prognosis: string[];
    reason_for_termination: string;
    discharge_plan_and_follow_up: string;
    condition_type: string;
    condition_type_additional_details: string;
    condition_status: string;
    condition_status_additional_details?: string;
    modality?: string;
    session_location: string;
    consent_was_received_for_the_teletherapy_session?: boolean;
    the_session_was_conducted_via_video?: boolean;
    location_of_the_client?: string;
    other_location_of_the_client?: string;
    location_of_the_provider?: string;
    other_location_of_the_provider?: string;
    signature?: string;
}

export interface IEditEvaluationManagementAndTherapyNoteMedPayload {
    diagnosis_codes: string[];
    secondary_diagnosis?: string[];
    tertiary_diagnosis?: string[];
    additional_diagnosis_one?: string[];
    additional_diagnosis_two?: string[];
    files?: string;
    interval_history: string;
    interval_psychiatric_assessment_mse: string;
    patient_ability_and_capability_to_respond_to_treatment?: string[];
    diminished_poor_or_limited_quality_patient_oriented_evidence_details?: string;
    condition_type: string;
    condition_type_additional_details?: string;
    condition_status: string;
    condition_status_additional_details?: string;
    current_medications_and_medications_changes: string;
    no_side_effects_or_adverse_reactions_noted_or_reported?: boolean;
    lab_tests?: string[];
    lab_tests_details?: string;
    additional_documentation_review_internal?: string;
    additional_documentation_review_external: string;
    independent_interpretation_of_tests: string;
    discussion_of_tests_or_management_with_external_professionals: string;
    use_of_an_independent_historian?: string;
    decision_regarding_hospitalization_or_patient_family_decision_to_forego_hospitalization_upon_shared_decision_making?: string;
    social_factors_which_may_impair_or_prevent_patients_from_receiving_care_and_or_treatment?: string;
    treatment_goal_one: string;
    treatment_goal_two: string;
    treatment_goal_three: string;
    progress_one: string;
    progress_two: string;
    progress_three: string;
    session_location: string;
    consent_was_received_for_the_teletherapy_session?: boolean;
    the_session_was_conducted_via_video?: boolean;
    frequency_of_sessions?: string[];
    other_frequency_of_sessions?: string;
    date_of_next_session: string;
    location_of_the_client?: string;
    other_location_of_the_client?: string;
    location_of_the_provider?: string;
    other_location_of_the_provider?: string;
    communication_factors_impacting_treatment?: string[];
    details_around_communication_factors_impacting_treatment?: string;
    narrative_describing_in_detail_the_issues_reviewed_with_patient: string;
    counseling_provided_with_patient_family_caregiver?: string[];
    type_of_therapy_performed: string;
    recommendations_and_plan: string;
    prognosis: string;
    modality: string;
    medication_management_duration: string;
    start_time_of_counseling: string;
    end_time_of_counseling: string;
    signature?: string;
}

export interface IEditEvaluationManagementNoteMedPayload {
    diagnosis_codes: string[];
    secondary_diagnosis?: string[];
    tertiary_diagnosis?: string[];
    additional_diagnosis_one?: string[];
    additional_diagnosis_two?: string[];
    files?: string;
    interval_history: string;
    interval_psychiatric_assessment_mse: string;
    patient_ability_and_capability_to_respond_to_treatment?: string[];
    diminished_poor_or_limited_quality_patient_oriented_evidence_details?: string;
    prognosis: string;
    condition_type: string;
    condition_type_additional_details?: string;
    condition_status: string;
    condition_status_additional_details?: string;
    current_medications_and_medications_changes: string;
    no_side_effects_or_adverse_reactions_noted_or_reported?: boolean;
    lab_tests?: string[];
    lab_tests_details?: string;
    additional_documentation_review_external: string;
    independent_interpretation_of_tests?: string;
    discussion_of_tests_or_management_with_external_professionals?: string;
    use_of_an_independent_historian?: string;
    treatment_goal_one: string;
    treatment_goal_two: string;
    treatment_goal_three: string;
    progress_one: string;
    progress_two: string;
    progress_three: string;
    session_location: string;
    consent_was_received_for_the_teletherapy_session?: boolean;
    the_session_was_conducted_via_video?: boolean;
    modality: string;
    location_of_the_client?: string;
    other_location_of_the_client?: string;
    location_of_the_provider?: string;
    other_location_of_the_provider?: string;
    frequency_of_sessions?: string[];
    other_frequency_of_sessions?: string;
    date_of_next_session: string;
    communication_factors_impacting_treatment?: string[];
    details_around_communication_factors_impacting_treatment?: string;
    signature?: string;
}

export interface IEditTreatmentReviewNoteMedPayload {
    diagnosis_codes: string[];
    secondary_diagnosis?: string[];
    tertiary_diagnosis?: string[];
    additional_diagnosis_one?: string[];
    additional_diagnosis_two?: string[];
    files?: string;
    chief_complaint: string;
    current_medications: string;
    allergies: string;
    historical_updates: string;
    other_persons_attending_the_interview_contribution_to_the_history_or_related_observations?: string;
    condition_type: string;
    condition_type_additional_details?: string;
    condition_status: string;
    condition_status_additional_details?: string;
    note: string;
    plan: string;
    prognosis: string;
    education_including_health_promotion_maintenance_and_psychosocial_needs: string;
    lab_work_ordered?: string;
    referrals_and_recommendations: string;
    overall_goals_of_care_frequency_and_duration_of_visits: string;
    treatment_goal_one: string;
    treatment_goal_two: string;
    treatment_goal_three: string;
    session_location: string;
    consent_was_received_for_the_teletherapy_session?: boolean;
    the_session_was_conducted_via_video?: boolean;
    location_of_the_client?: string;
    other_location_of_the_client?: string;
    location_of_the_provider?: string;
    other_location_of_the_provider?: string;
    communication_factors_impacting_treatment?: string[];
    details_around_communication_factors_impacting_treatment?: string;
    appearance: string;
    movement: string;
    speech: string;
    affect_mood: string;
    attention_concentration_cognition: string;
    overall_presentation: string;
    patient_ability_and_capability_to_respond_to_treatment?: string[];
    diminished_poor_or_limited_quality_patient_oriented_evidence_details?: string;
    ros: string;
    current_suicidal_ideation?: string;
    current_homicidal_ideation?: string;
    reported_violent_behavior?: string;
    inappropriate_illegal_behaviors?: string;
    history_of_violence_to_self?: string;
    history_of_violence_to_others?: string;
    auditory_hallucinations?: string;
    visual_hallucinations?: string;
    other_pertinent_information?: string;
    lab_test_data_review?: string;
    psychiatric_screening_measure_results: string;
    signature?: string;
}

export interface IEditIntakeNoteMedPayload {
    diagnosis_codes: string[];
    secondary_diagnosis?: string[];
    tertiary_diagnosis?: string[];
    additional_diagnosis_one?: string[];
    additional_diagnosis_two?: string[];
    files?: string;
    note: string;
    plan: string;
    frequency_of_sessions?: string[];
    other_frequency_of_sessions?: string;
    date_of_next_session: string;
    prognosis: string;
    education_including_health_promotion_maintenance_and_psychosocial_needs: string;
    lab_work_ordered?: string;
    referrals_and_recommendations: string;
    overall_goals_of_care_frequency_and_duration_of_visits: string;
    treatment_goal_one: string;
    treatment_goal_two: string;
    treatment_goal_three: string;
    session_location: string;
    consent_was_received_for_the_teletherapy_session?: boolean;
    the_session_was_conducted_via_video?: boolean;
    modality: string;
    location_of_the_client?: string;
    other_location_of_the_client?: string;
    location_of_the_provider?: string;
    other_location_of_the_provider?: string;
    communication_factors_impacting_treatment?: string[];
    details_around_communication_factors_impacting_treatment?: string;
    preferred_name: string;
    pronoun: string;
    sex?: string;
    gender_identity?: string;
    sexual_orientation?: string;
    monogamous_polyamorous?: string;
    religion?: string;
    religion_details?: string;
    race?: string;
    ethnicity?: string;
    education?: string;
    current_employment?: string;
    relationship?: string;
    relationship_details?: string;
    emergency_contact_information: string;
    names_and_relations_of_others_present_in_the_interview?: string;
    appearance: string;
    movement: string;
    speech_orientation: string;
    affect_mood: string;
    attention_concentration_cognition: string;
    overall_presentation: string;
    patient_ability_and_capability_to_respond_to_treatment: string[];
    diminished_poor_or_limited_quality_patient_oriented_evidence_details?: string;
    chief_complaint: string;
    history_of_present_illness: string;
    past_psychiatric_history: string;
    past_medical_history: string;
    past_psychiatric_hospitalization: string;
    current_medications: string;
    allergies: string;
    social_history: string;
    family_history: string;
    trauma_history: string;
    lifestyle_excercise_diet_sleep: string;
    ros: string;
    current_suicidal_ideation: string;
    current_homicidal_ideation: string;
    reported_violent_behavior: string;
    inappropriate_illegal_behaviors: string;
    history_of_violence_to_self: string;
    history_of_violence_to_others: string;
    auditory_hallucinations: string;
    visual_hallucinations: string;
    other_pertinent_information?: string;
    lab_test_data_review?: string;
    psychiatric_screening_measure_results: string;
    signature?: string;
}

export interface IEditRecordOfDisclosurePsychPayload {
    duration: string;
    diagnosis_codes: string[];
    secondary_diagnosis?: string[];
    tertiary_diagnosis?: string[];
    additional_diagnosis_one?: string[];
    additional_diagnosis_two?: string[];
    disclosure_to_whom: string;
    disclosure_type: string;
    purpose_of_disclosure: string;
    type_disclosed: string;
    method_of_disclosure: string;
    other_method_of_disclosure: string;
    record_of_disclosure_of_phi_ephi: string;
    signature?: string;
}

export interface IEditSafetyPlanPayload {
    diagnosis_codes: string[];
    secondary_diagnosis?: string[];
    tertiary_diagnosis?: string[];
    additional_diagnosis_one?: string[];
    additional_diagnosis_two?: string[];
    warning_signs: string;
    internal_coping_strategies: string;
    people_and_social_settings_that_provide_distraction: string;
    people_whom_i_can_ask_for_help: string;
    professionals_or_agencies_i_can_contact_during_a_crisis: string;
    making_the_environment_safe: string;
    the_one_thing_that_is_important_to_me_and_worth_living_for_is: string;
    how_likely_is_the_client_to_use_this_safety_plan: string;
    how_likely_is_the_client_to_adhere_to_this_safety_plan: string;
    detail_hloc_options_and_next_steps: string;
    where_will_the_client_keep_the_safety_plan_and_how_will_it_be_located_during_a_crisis: string;
    is_the_format_appropriate_for_client_capacity_and_circumstances: string;
    when_should_follow_up_be_done_for_this_client: string;
    frequency_of_sessions: string;
    other_frequency_of_sessions: string;
    date_of_next_session: string;
    date_created: string;
    signature: string;
}

export interface IEditSoapNote {
    isClientPresent: boolean;
    duration: string;
    appointment_location: string;
    delivery_option: string;
    provider_location: string;
    other_provider_location?: string;
    consent_was_received_for_the_teletherapy_session: boolean;
    the_teletherapy_session_was_conducted_via_video: boolean;
    diagnosis_codes: string[];
    secondary_diagnosis: string[];
    tertiary_diagnosis: string[];
    additional_diagnosis_one?: string[];
    additional_diagnosis_two?: string[];
    emotional_behavioural_symptoms_demonstrated: string;
    causing: string;
    intention_for_session: string;
    other_delivery_option?: string;
    subjective: string;
    objective: string;
    assessment: string;
    cognitive_behavioral_therapies: string[];
    relationship_based_interventions: string[];
    other: string[];
    plan: string;
    frequency_of_sessions: string;
    other_frequency_of_sessions: string;
    date_of_next_session: string;
    prognosis: string;
    client_response: string;
    goal_one: string;
    goal_two: string;
    goal_three: string;
    progress_one: string;
    progress_two: string;
    progress_three: string;
    signature?: string;
}

export interface IEditSupervisionNotePayload {
    supervision_note: string;
    client_progress: string;
    signature?: string;
}

export interface IEditSupervisorCheckInNotePayload {
    update: string;
    signature?: string;
}

export interface IEditTerminationNotePayload {
    duration: string;
    appointment_location: string;
    delivery_option: string;
    provider_location: string;
    other_provider_location?: string;
    consent_was_received_for_the_teletherapy_session: boolean;
    the_teletherapy_session_was_conducted_via_video: boolean;
    total_number_of_sessions: string;
    other_delivery_option?: string;
    diagnosis_codes: string[];
    secondary_diagnosis: string[];
    tertiary_diagnosis: string[];
    additional_diagnosis_one?: string[];
    additional_diagnosis_two?: string[];
    first_session_date: string;
    last_session_date: string;
    presenting_problems: string;
    planned_treatment_and_goals: string;
    course_of_treatment: string;
    patient_final_condition: string;
    prognosis: string;
    reason_for_termination: string;
    discharge_plan_and_follow_up: string;
    date_created: string;
    notify_client: boolean;
    reason_for_not_notifying_client: string;
    signature: string;
}

export interface FamilyTreatmentReviewNote {
    name: string;
    gender: string;
    other_gender: string;
    preferred_name: string;
    pronouns: string;
    other_sexual_orientation: string;
    religion: string;
    education: string;
    race: string;
    ethnicity: string;
    sexual_orientation: string;
    current_employment: string;
    current_employment_details: string;
    relationship_status: string;
    name_of_partner: string;
    emergency_contact_information: string;
    legal_problems: string;
    anxiety_frequency: string;
    anxiety_details: string;
    panic_attacks_freqency: string;
    panic_attacks_details: string;
    depression_freqency: string;
    depression_details: string;
    selected_symptoms: string[];
    other_symptoms: string;
    physical_symptoms: string;
    medication_physical_psychiatric: string;
    sleeping_habits_and_concerns: string;
    difficulties_with_appetite_or_eating_patterns: string;
    been_so_distressed_you_seriously_wished_to_end_your_life: string;
    describe_been_so_distressed_you_seriously_wished_to_end_your_life?: string;
    has_anything_happened_recently_to_make_you_feel_you_dont_want_to_live: string;
    describe_has_anything_happened_recently_to_make_you_feel_you_dont_want_to_live?: string;
    a_specific_plan_of_how_you_would_kill_yourself: string;
    describe_a_specific_plan_of_how_you_would_kill_yourself?: string;
    access_to_weapons_or_means_of_hurting_self: string;
    describe_access_to_weapons_or_means_of_hurting_self?: string;
    made_serious_suicide_attempts: string;
    describe_made_serious_suicide_attempts?: string;
    purposely_done_something_to_hurt_yourself: string;
    describe_done_something_to_hurt_yourself?: string;
    heard_voices_telling_you_to_hurt_yourself: string;
    describe_heard_voices_telling_you_to_hurt_yourself?: string;
    had_relatives_who_attempted_or_commited_sucide: string;
    describe_had_relatives_who_attempted_or_commited_sucide?: string;
    had_thoughts_of_killing_or_seriously_hurting_someone: string;
    describe_had_thoughts_of_killing_or_seriously_hurting_someone?: string;
    heard_voices_telling_you_to_hurt_others: string;
    describe_heard_voices_telling_you_to_hurt_others?: string;
    hurt_someone_or_destroyed_property_on_purpose: string;
    describe_hurt_someone_or_destroyed_property_on_purpose?: string;
    slapped_kicked_punched_someone_with_intent_to_harm: string;
    describe_slapped_kicked_punched_someone_with_intent_to_harm?: string;
    been_arrested_or_detained_for_violent_behavior: string;
    describe_been_arrested_or_detained_for_violent_behavior?: string;
    been_to_jail_for_any_reason: string;
    describe_been_to_jail_for_any_reason?: string;
    been_on_probation_for_any_reason: string;
    describe_been_on_probation_for_any_reason?: string;
    do_you_have_access_to_guns: string;
    describe_do_you_have_access_to_guns?: string;
    patients_ability_and_capability_to_respond_to_treatment: string[];
    details_for_diminished_poor_limited_quality_patient_oriented_evidence: string;
    anxiety?: boolean;
    panic_attacks?: boolean;
    depression?: boolean;
    family_id?: string;
}

export const emptyFamilyTreatmentReviewNote: FamilyTreatmentReviewNote = {
    name: "",
    gender: "",
    other_gender: "",
    preferred_name: "",
    pronouns: "",
    other_sexual_orientation: "",
    religion: "",
    education: "",
    race: "",
    ethnicity: "",
    sexual_orientation: "",
    current_employment: "",
    current_employment_details: "",
    relationship_status: "",
    name_of_partner: "",
    emergency_contact_information: "",
    legal_problems: "",
    anxiety_frequency: "",
    anxiety_details: "",
    panic_attacks_freqency: "",
    panic_attacks_details: "",
    depression_freqency: "",
    depression_details: "",
    selected_symptoms: [],
    other_symptoms: "",
    physical_symptoms: "",
    medication_physical_psychiatric: "",
    sleeping_habits_and_concerns: "",
    difficulties_with_appetite_or_eating_patterns: "",
    been_so_distressed_you_seriously_wished_to_end_your_life: "",
    describe_been_so_distressed_you_seriously_wished_to_end_your_life: "",
    has_anything_happened_recently_to_make_you_feel_you_dont_want_to_live: "",
    describe_has_anything_happened_recently_to_make_you_feel_you_dont_want_to_live:
        "",
    a_specific_plan_of_how_you_would_kill_yourself: "",
    describe_a_specific_plan_of_how_you_would_kill_yourself: "",
    access_to_weapons_or_means_of_hurting_self: "",
    describe_access_to_weapons_or_means_of_hurting_self: "",
    made_serious_suicide_attempts: "",
    describe_made_serious_suicide_attempts: "",
    purposely_done_something_to_hurt_yourself: "",
    describe_done_something_to_hurt_yourself: "",
    heard_voices_telling_you_to_hurt_yourself: "",
    describe_heard_voices_telling_you_to_hurt_yourself: "",
    had_relatives_who_attempted_or_commited_sucide: "",
    describe_had_relatives_who_attempted_or_commited_sucide: "",
    had_thoughts_of_killing_or_seriously_hurting_someone: "",
    describe_had_thoughts_of_killing_or_seriously_hurting_someone: "",
    heard_voices_telling_you_to_hurt_others: "",
    describe_heard_voices_telling_you_to_hurt_others: "",
    hurt_someone_or_destroyed_property_on_purpose: "",
    describe_hurt_someone_or_destroyed_property_on_purpose: "",
    slapped_kicked_punched_someone_with_intent_to_harm: "",
    describe_slapped_kicked_punched_someone_with_intent_to_harm: "",
    been_arrested_or_detained_for_violent_behavior: "",
    describe_been_arrested_or_detained_for_violent_behavior: "",
    been_to_jail_for_any_reason: "",
    describe_been_to_jail_for_any_reason: "",
    been_on_probation_for_any_reason: "",
    describe_been_on_probation_for_any_reason: "",
    do_you_have_access_to_guns: "",
    describe_do_you_have_access_to_guns: "",
    patients_ability_and_capability_to_respond_to_treatment: [],
    details_for_diminished_poor_limited_quality_patient_oriented_evidence: "",
    anxiety: false,
    panic_attacks: false,
    depression: false,
};

export interface IEditTreatmentReviewNotePayload {
    isClientPresent: boolean;
    duration: string;
    appointment_location: string;
    delivery_option: string;
    provider_location: string;
    other_provider_location?: string;
    consent_was_received_for_the_teletherapy_session: boolean;
    the_teletherapy_session_was_conducted_via_video: boolean;
    other_delivery_option?: string;
    diagnosis_codes: string[];
    secondary_diagnosis: string[];
    tertiary_diagnosis: string[];
    additional_diagnosis_one?: string[];
    additional_diagnosis_two?: string[];
    what_are_the_problem_you_are_seeking_help_for: string;
    anxiety_frequency: string;
    anxiety_details: string;
    panic_attacks_freqency: string;
    panic_attacks_details: string;
    depression_freqency: string;
    depression_details: string;
    selected_symptoms: string;
    other_symptoms: string[];
    physical_symptoms: string;
    medication_physical_psychiatric: string;
    sleeping_habits_and_concerns: string;
    difficulties_with_appetite_or_eating_patterns: string;
    been_so_distressed_you_seriously_wished_to_end_your_life: string;
    describe_been_so_distressed_you_seriously_wished_to_end_your_life?: string;
    has_anything_happened_recently_to_make_you_feel_you_dont_want_to_live: string;
    describe_has_anything_happened_recently_to_make_you_feel_you_dont_want_to_live?: string;
    a_specific_plan_of_how_you_would_kill_yourself: string;
    describe_a_specific_plan_of_how_you_would_kill_yourself?: string;
    access_to_weapons_or_means_of_hurting_self: string;
    describe_access_to_weapons_or_means_of_hurting_self?: string;
    made_serious_suicide_attempts: string;
    describe_made_serious_suicide_attempts?: string;
    purposely_done_something_to_hurt_yourself: string;
    describe_done_something_to_hurt_yourself?: string;
    heard_voices_telling_you_to_hurt_yourself: string;
    describe_heard_voices_telling_you_to_hurt_yourself?: string;
    had_relatives_who_attempted_or_commited_sucide: string;
    describe_had_relatives_who_attempted_or_commited_sucide?: string;
    had_thoughts_of_killing_or_seriously_hurting_someone: string;
    describe_had_thoughts_of_killing_or_seriously_hurting_someone?: string;
    heard_voices_telling_you_to_hurt_others: string;
    describe_heard_voices_telling_you_to_hurt_others?: string;
    hurt_someone_or_destroyed_property_on_purpose: string;
    describe_hurt_someone_or_destroyed_property_on_purpose?: string;
    slapped_kicked_punched_someone_with_intent_to_harm: string;
    describe_slapped_kicked_punched_someone_with_intent_to_harm?: string;
    been_arrested_or_detained_for_violent_behavior: string;
    describe_been_arrested_or_detained_for_violent_behavior?: string;
    been_to_jail_for_any_reason: string;
    describe_been_to_jail_for_any_reason?: string;
    been_on_probation_for_any_reason: string;
    describe_been_on_probation_for_any_reason?: string;
    do_you_have_access_to_guns: string;
    describe_do_you_have_access_to_guns?: string;
    ever_run_away_from_home?: string;
    describe_ever_run_away_from_home?: string;
    ever_been_bullied_or_bullied_someone?: string;
    describe_ever_been_bullied_or_bullied_someone?: string;
    patients_ability_and_capability_to_respond_to_treatment: string[];
    details_for_diminished_poor_limited_quality_patient_oriented_evidence: string;
    people_present_at_session: string[];
    other_person_present_at_session: string;
    type_of_treatment_recommended: string[];
    treatment_modality_intervention: string[];
    other_treatment_modality_intervention: string;
    treatment_goal_one: string;
    treatment_goal_two: string;
    treatment_goal_three: string;
    medication_updates: string;
    frequency_of_sessions: string;
    other_frequency_of_sessions: string;
    expected_termination_date: string;
    plan_of_care: string;
    prognosis: string;
    subjective_report: string;
    summary: string;
    anxiety?: boolean;
    panic_attacks?: boolean;
    depression?: boolean;
    signature: string;
}

export interface IEditFamilyTreatmentReviewNotePayload {
    family: FamilyTreatmentReviewNote[];
    signature?: string;
    appointment_location: string;
    isClientPresent: boolean;
    diagnosis_codes: string[];
    secondary_diagnosis: string[];
    tertiary_diagnosis: string[];
    additional_diagnosis_one?: string[];
    additional_diagnosis_two?: string[];
    delivery_option: string;
    provider_location: string;
    other_provider_location?: string;
    other_delivery_option?: string;
    consent_was_received_for_the_teletherapy_session: boolean;
    the_teletherapy_session_was_conducted_via_video: boolean;
    duration: string;
    what_are_the_problem_you_are_seeking_help_for: string;
    people_present_at_session: string[];
    other_person_present_at_session: string;
    type_of_treatment_recommended: string[];
    treatment_modality_intervention: string[];
    other_treatment_modality_intervention: string;
    treatment_goal_one: string;
    treatment_goal_two: string;
    treatment_goal_three: string;
    frequency_of_sessions: string;
    expected_termination_date: string;
    plan_of_care: string;
    other_frequency_of_sessions: string;
    medication_updates: string;
    date_of_next_session: string;
    subjective_report: string;
    summary: string;
    prognosis: string;
}

export interface IEditStandardTestingNotePayload {
    duration: string;
    diagnosis_codes: string[];
    secondary_diagnosis: string[];
    tertiary_diagnosis: string[];
    additional_diagnosis_one: string[];
    additional_diagnosis_two: string[];
    summary: string;
    signature?: string;
}

export interface IEditTerminationOfTreatmentPayload {
    duration: string;
    appointment_location: string;
    delivery_option: string;
    provider_location: string;
    other_provider_location?: string;
    first_session_date: string;
    last_session_date: string;
    diagnosis_codes: string[];
    secondary_diagnosis: string[];
    tertiary_diagnosis: string[];
    additional_diagnosis_one?: string[];
    additional_diagnosis_two?: string[];
    total_number_of_sessions: string;
    presenting_problems: string;
    planned_treatment_and_goals: string;
    course_of_treatment: string;
    patient_final_condition: string;
    prognosis: string;
    other_delivery_option: string;
    reason_for_termination: string;
    discharge_plan_and_follow_up: string;
    consent_was_received_for_the_teletherapy_session: boolean;
    the_teletherapy_session_was_conducted_via_video: boolean;
    treatment_modality_intervention: string[];
    other_treatment_modality_intervention: string;
    signature?: string;
}

export interface IEditInitialDiagnosticEvaluationPayload {
    appointment_location: string;
    diagnosis_codes: string[];
    secondary_diagnosis: string[];
    tertiary_diagnosis: string[];
    additional_diagnosis_one?: string[];
    additional_diagnosis_two?: string[];
    delivery_option: string;
    provider_location: string;
    other_provider_location?: string;
    consent_was_received_for_the_teletherapy_session: boolean;
    the_teletherapy_session_was_conducted_via_video: boolean;
    other_delivery_option?: string;
    duration: string;
    gender: string;
    other_gender: string;
    preferred_name: string;
    pronouns: string;
    other_sexual_orientation: string;
    religion: string;
    education: string;
    race: string;
    ethnicity: string;
    sexual_orientation: string;
    current_employment: string;
    current_employment_details: string;
    relationship_status: string;
    name_of_partner: string;
    emergency_contact_information: string;
    legal_problems: string;
    what_are_the_problem_you_are_seeking_help_for: string;
    anxiety_frequency: string;
    anxiety_details: string;
    panic_attacks_frequency: string;
    panic_attacks_details: string;
    depression_frequency: string;
    depression_details: string;
    selected_symptoms: string;
    other_symptoms: string[];
    physical_symptoms: string;
    medication_physical_psychiatric: string;
    sleeping_habits_and_concerns: string;
    difficulties_with_appetite_or_eating_patterns: string;
    parents_stepparents_history: string;
    siblings_history: string;
    grandparents_history: string;
    children_history: string;
    other_family_members_history: string;
    family_members_alcohol_abuse: string[];
    family_members_alcohol_abuse_other: string;
    family_members_anxiety: string[];
    family_members_anxiety_other: string;
    family_members_bipolar_disorder: string[];
    family_members_bipolar_disorder_other: string;
    family_members_depression: string[];
    family_members_depression_other: string;
    family_members_ptsd: string[];
    family_members_ptsd_other: string;
    family_members_schizophrenia: string[];
    family_members_schizophrenia_other: string;
    family_members_substance_abuse: string[];
    family_members_substance_abuse_other: string;
    family_members_substance_abuse_substance: string;
    trauma_abuse_history: string;
    previous_mental_health_treatment_oupatient: string;
    impatient_psychiatric_hospitalization: string;
    relevant_medical_history: string;
    been_so_distressed_you_seriously_wished_to_end_your_life: string;
    describe_been_so_distressed_you_seriously_wished_to_end_your_life?: string;
    has_anything_happened_recently_to_make_you_feel_you_dont_want_to_live: string;
    describe_has_anything_happened_recently_to_make_you_feel_you_dont_want_to_live?: string;
    a_specific_plan_of_how_you_would_kill_yourself: string;
    describe_a_specific_plan_of_how_you_would_kill_yourself?: string;
    access_to_weapons_or_means_of_hurting_self: string;
    describe_access_to_weapons_or_means_of_hurting_self?: string;
    made_serious_suicide_attempts: string;
    describe_made_serious_suicide_attempts?: string;
    purposely_done_something_to_hurt_yourself: string;
    describe_done_something_to_hurt_yourself?: string;
    heard_voices_telling_you_to_hurt_yourself: string;
    describe_heard_voices_telling_you_to_hurt_yourself?: string;
    had_relatives_who_attempted_or_committed_suicide: string;
    describe_had_relatives_who_attempted_or_committed_suicide?: string;
    had_thoughts_of_killing_or_seriously_hurting_someone: string;
    describe_had_thoughts_of_killing_or_seriously_hurting_someone: string;
    heard_voices_telling_you_to_hurt_others: string;
    describe_heard_voices_telling_you_to_hurt_others: string;
    hurt_someone_or_destroyed_property_on_purpose: string;
    describe_hurt_someone_or_destroyed_property_on_purpose: string;
    slapped_kicked_punched_someone_with_intent_to_harm: string;
    describe_slapped_kicked_punched_someone_with_intent_to_harm: string;
    been_arrested_or_detained_for_violent_behavior: string;
    describe_been_arrested_or_detained_for_violent_behavior: string;
    been_to_jail_for_any_reason: string;
    describe_been_to_jail_for_any_reason: string;
    been_on_probation_for_any_reason: string;
    describe_been_on_probation_for_any_reason: string;
    do_you_have_access_to_guns: string;
    describe_do_you_have_access_to_guns: string;
    mental_health_appearance: string[];
    mental_health_movement: string[];
    mental_health_speech_behaviour: string[];
    mental_health_affect_mood: string[];
    mental_health_attention_concentration_effort: string[];
    mental_health_presentation_of_self: string[];
    mental_health_cognition: string[];
    patients_ability_and_capability_to_respond_to_treatment: string[];
    details_for_diminished_poor_limited_quality_patient_oriented_evidence: string;
    people_present_at_session: string[];
    other_person_present_at_session: string;
    type_of_treatment_recommended: string[];
    treatment_modality_intervention: string[];
    other_treatment_modality_intervention: string;
    treatment_goal_one: string;
    treatment_goal_two: string;
    treatment_goal_three: string;
    frequency_of_sessions: string;
    other_frequency_of_sessions: string;
    date_of_next_session: string;
    subjective_report: string;
    summary: string;
    prognosis: string;
    contact_information_for_both_parents: string;
    name_address_of_personal_physician: string;
    date_of_last_exam: string;
    anxiety?: boolean;
    panic_attacks?: boolean;
    depression?: boolean;
    supervisory_intake_statement: string[];
    medical_necessity_rationale: string[];
    risk_review_supervision_plan: string[];
    formal_safety_plan_details?: string;
    higher_level_of_care_details?: string;
    ever_run_away_from_home?: string;
    describe_ever_run_away_from_home?: string;
    ever_been_bullied_or_bullied_someone?: string;
    describe_ever_been_bullied_or_bullied_someone?: string;
    signature?: string;
}

export interface IEditInitialSoapNote {
    isClientPresent: boolean;
    duration: string;
    appointment_location: string;
    delivery_option: string;
    provider_location: string;
    other_provider_location?: string;
    consent_was_received_for_the_teletherapy_session: boolean;
    the_teletherapy_session_was_conducted_via_video: boolean;
    diagnosis_codes: string[];
    secondary_diagnosis: string[];
    tertiary_diagnosis: string[];
    additional_diagnosis_one?: string[];
    additional_diagnosis_two?: string[];
    emotional_behavioural_symptoms_demonstrated: string;
    causing: string;
    intention_for_session: string;
    other_delivery_option?: string;
    subjective: string;
    objective: string;
    assessment: string;
    cognitive_behavioral_therapies: string[];
    relationship_based_interventions: string[];
    other: string[];
    plan: string;
    frequency_of_sessions: string;
    other_frequency_of_sessions: string;
    date_of_next_session: string;
    prognosis: string;
    client_response: string;
    goal_one: string;
    goal_two: string;
    goal_three: string;
    progress_one: string;
    progress_two: string;
    progress_three: string;
    risk_and_safety_language: string;
    new_risk_concerns_details?: string;
    additional_client_reported_information_post_intake?: string;
    signature?: string;
}

export interface IEditSupervisorDiagnosticReview {
    date_of_review: string;
    diagnosis_codes: string[];
    revised_diagnosis_codes: string[];
    new_clinical_information_supporting_diagnostic_change: string;
    diagnostic_rationale: string;
    reviewed_and_approved_by_lp: string;
    signature?: string;
}

export interface FamilyInitialDiagnosticEvaluationNotePayload {
    name: string;
    gender: string;
    other_gender: string;
    preferred_name: string;
    pronouns: string;
    other_sexual_orientation: string;
    religion: string;
    education: string;
    race: string;
    ethinicity: string;
    sexual_orientation: string;
    current_employment: string;
    current_employment_details: string;
    relationship_status: string;
    name_of_partner: string;
    emergency_contact_information: string;
    legal_problems: string;
    anxiety_frequency: string;
    anxiety_details: string;
    panic_attacks_freqency: string;
    panic_attacks_details: string;
    depression_freqency: string;
    depression_details: string;
    selected_symptoms: string[];
    other_symptoms: string;
    physical_symptoms: string;
    medication_physical_psychiatric: string;
    sleeping_habits_and_concerns: string;
    difficulties_with_appetite_or_eating_patterns: string;
    parents_stepparents_history: string;
    siblings_history: string;
    grandparents_history: string;
    children_history: string;
    other_family_members_history: string;
    family_members_alcohol_abuse: string[];
    family_members_alcohol_abuse_other: string;
    family_members_anxiety: string[];
    family_members_anxiety_other: string;
    family_members_bipolar_disorder: string[];
    family_members_bipolar_disorder_other: string;
    family_members_depression: string[];
    family_members_depression_other: string;
    family_members_ptsd: string[];
    family_members_ptsd_other: string;
    family_members_schizophrenia: string[];
    family_members_schizophrenia_other: string;
    family_members_substance_abuse: string[];
    family_members_substance_abuse_other: string;
    family_members_substance_abuse_substance: string;
    trauma_abuse_history: string;
    previous_mental_health_treatment_oupatient: string;
    impatient_psychiatric_hospitalization: string;
    relevant_medical_history: string;
    been_so_distressed_you_seriously_wished_to_end_your_life: string;
    describe_been_so_distressed_you_seriously_wished_to_end_your_life?: string;
    has_anything_happened_recently_to_make_you_feel_you_dont_want_to_live: string;
    describe_has_anything_happened_recently_to_make_you_feel_you_dont_want_to_live?: string;
    a_specific_plan_of_how_you_would_kill_yourself: string;
    describe_a_specific_plan_of_how_you_would_kill_yourself?: string;
    access_to_weapons_or_means_of_hurting_self: string;
    describe_access_to_weapons_or_means_of_hurting_self?: string;
    made_serious_suicide_attempts: string;
    describe_made_serious_suicide_attempts?: string;
    purposely_done_something_to_hurt_yourself: string;
    describe_done_something_to_hurt_yourself?: string;
    heard_voices_telling_you_to_hurt_yourself: string;
    describe_heard_voices_telling_you_to_hurt_yourself?: string;
    had_relatives_who_attempted_or_commited_sucide: string;
    describe_had_relatives_who_attempted_or_commited_sucide?: string;
    had_thoughts_of_killing_or_seriously_hurting_someone: string;
    describe_had_thoughts_of_killing_or_seriously_hurting_someone?: string;
    heard_voices_telling_you_to_hurt_others: string;
    describe_heard_voices_telling_you_to_hurt_others?: string;
    hurt_someone_or_destroyed_property_on_purpose: string;
    describe_hurt_someone_or_destroyed_property_on_purpose?: string;
    slapped_kicked_punched_someone_with_intent_to_harm: string;
    describe_slapped_kicked_punched_someone_with_intent_to_harm?: string;
    been_arrested_or_detained_for_violent_behavior: string;
    describe_been_arrested_or_detained_for_violent_behavior?: string;
    been_to_jail_for_any_reason: string;
    describe_been_to_jail_for_any_reason?: string;
    been_on_probation_for_any_reason: string;
    describe_been_on_probation_for_any_reason?: string;
    do_you_have_access_to_guns: string;
    describe_do_you_have_access_to_guns?: string;
    mental_health_appearance: string[];
    mental_health_movement: string[];
    mental_health_speech_behaviour: string[];
    mental_health_affect_mood: string[];
    mental_health_attention_concentration_effort: string[];
    mental_health_presentation_of_self: string[];
    mental_health_cognition: string[];
    patients_ability_and_capability_to_respond_to_treatment: string[];
    details_for_diminished_poor_limited_quality_patient_oriented_evidence: string;
    anxiety?: boolean;
    panic_attacks?: boolean;
    depression?: boolean;
    family_id?: string;
}

export interface IEditFamilyInitialDiagnosticEvaluationPayload {
    family: FamilyInitialDiagnosticEvaluationNotePayload[];
    signature?: string;
    appointment_location: string;
    isClientPresent?: boolean;
    diagnosis_codes: string[];
    secondary_diagnosis: string[];
    tertiary_diagnosis: string[];
    additional_diagnosis_one?: string[];
    additional_diagnosis_two?: string[];
    delivery_option: string;
    provider_location: string;
    other_provider_location?: string;
    other_delivery_option?: string;
    consent_was_received_for_the_teletherapy_session: boolean;
    the_teletherapy_session_was_conducted_via_video: boolean;
    duration: string;
    what_are_the_problem_you_are_seeking_help_for: string;
    people_present_at_session: string[];
    other_person_present_at_session: string;
    type_of_treatment_recommended: string[];
    treatment_modality_intervention: string[];
    other_treatment_modality_intervention: string;
    treatment_goal_one: string;
    treatment_goal_two: string;
    treatment_goal_three: string;
    frequency_of_sessions: string;
    other_frequency_of_sessions: string;
    date_of_next_session: string;
    subjective_report: string;
    summary: string;
    prognosis: string;
    supervisory_intake_statement: string[];
    medical_necessity_rationale: string[];
    risk_review_supervision_plan: string[];
    formal_safety_plan_details?: string;
    higher_level_of_care_details?: string;
}

export const emptyFamilyInitialDiagnosticEvaluationNote: FamilyInitialDiagnosticEvaluationNotePayload =
    {
        name: "",
        gender: "",
        other_gender: "",
        preferred_name: "",
        pronouns: "",
        other_sexual_orientation: "",
        religion: "",
        education: "",
        race: "",
        ethinicity: "",
        sexual_orientation: "",
        current_employment: "",
        current_employment_details: "",
        relationship_status: "",
        name_of_partner: "",
        emergency_contact_information: "",
        legal_problems: "",
        anxiety_frequency: "",
        anxiety_details: "",
        panic_attacks_freqency: "",
        panic_attacks_details: "",
        depression_freqency: "",
        depression_details: "",
        selected_symptoms: [],
        other_symptoms: "",
        physical_symptoms: "",
        medication_physical_psychiatric: "",
        sleeping_habits_and_concerns: "",
        difficulties_with_appetite_or_eating_patterns: "",
        parents_stepparents_history: "",
        siblings_history: "",
        grandparents_history: "",
        children_history: "",
        other_family_members_history: "",
        family_members_alcohol_abuse: [],
        family_members_alcohol_abuse_other: "",
        family_members_anxiety: [],
        family_members_anxiety_other: "",
        family_members_bipolar_disorder: [],
        family_members_bipolar_disorder_other: "",
        family_members_depression: [],
        family_members_depression_other: "",
        family_members_ptsd: [],
        family_members_ptsd_other: "",
        family_members_schizophrenia: [],
        family_members_schizophrenia_other: "",
        family_members_substance_abuse: [],
        family_members_substance_abuse_other: "",
        family_members_substance_abuse_substance: "",
        trauma_abuse_history: "",
        previous_mental_health_treatment_oupatient: "",
        impatient_psychiatric_hospitalization: "",
        relevant_medical_history: "",
        been_so_distressed_you_seriously_wished_to_end_your_life: "",
        describe_been_so_distressed_you_seriously_wished_to_end_your_life: "",
        has_anything_happened_recently_to_make_you_feel_you_dont_want_to_live:
            "",
        describe_has_anything_happened_recently_to_make_you_feel_you_dont_want_to_live:
            "",
        a_specific_plan_of_how_you_would_kill_yourself: "",
        describe_a_specific_plan_of_how_you_would_kill_yourself: "",
        access_to_weapons_or_means_of_hurting_self: "",
        describe_access_to_weapons_or_means_of_hurting_self: "",
        made_serious_suicide_attempts: "",
        describe_made_serious_suicide_attempts: "",
        purposely_done_something_to_hurt_yourself: "",
        describe_done_something_to_hurt_yourself: "",
        heard_voices_telling_you_to_hurt_yourself: "",
        describe_heard_voices_telling_you_to_hurt_yourself: "",
        had_relatives_who_attempted_or_commited_sucide: "",
        describe_had_relatives_who_attempted_or_commited_sucide: "",
        had_thoughts_of_killing_or_seriously_hurting_someone: "",
        describe_had_thoughts_of_killing_or_seriously_hurting_someone: "",
        heard_voices_telling_you_to_hurt_others: "",
        describe_heard_voices_telling_you_to_hurt_others: "",
        hurt_someone_or_destroyed_property_on_purpose: "",
        describe_hurt_someone_or_destroyed_property_on_purpose: "",
        slapped_kicked_punched_someone_with_intent_to_harm: "",
        describe_slapped_kicked_punched_someone_with_intent_to_harm: "",
        been_arrested_or_detained_for_violent_behavior: "",
        describe_been_arrested_or_detained_for_violent_behavior: "",
        been_to_jail_for_any_reason: "",
        describe_been_to_jail_for_any_reason: "",
        been_on_probation_for_any_reason: "",
        describe_been_on_probation_for_any_reason: "",
        do_you_have_access_to_guns: "",
        describe_do_you_have_access_to_guns: "",
        mental_health_appearance: [],
        mental_health_movement: [],
        mental_health_speech_behaviour: [],
        mental_health_affect_mood: [],
        mental_health_attention_concentration_effort: [],
        mental_health_presentation_of_self: [],
        mental_health_cognition: [],
        patients_ability_and_capability_to_respond_to_treatment: [],
        details_for_diminished_poor_limited_quality_patient_oriented_evidence:
            "",
        anxiety: false,
        panic_attacks: false,
        depression: false,
    };

export type EditNoteFormsPayload =
    | IEditCancellationNotePayload
    | IEditFamilyIntakeNote
    | IEditFamilyInitialDiagnosticEvaluationPayload
    | IEditFamilyTreatmentReviewNotePayload
    | IEditGeneralNotesPayload
    | IEditIndividualIntakeNote
    | IEditInitialSoapNote
    | IEditInitialDiagnosticEvaluationPayload
    | IEditRecordOfDisclosurePayload
    | IEditSafetyPlanPayload
    | IEditSoapNote
    | IEditSupervisionNotePayload
    | IEditSupervisorCheckInNotePayload
    | IEditSupervisorDiagnosticReview
    | IEditTerminationNotePayload
    | IEditTreatmentReviewNotePayload
    | IEditPauseNotificationNote
    | IEditStandardTestingNotePayload
    | IEditPauseNotificationPsychNotePayload
    | IEditNoShowPsychNotePayload
    | IEditCommunicationWithClientNotePayload
    | IEditFormsAndDocumentationNotePayload
    | IEditRecordOfDisclosurePsychPayload
    | IEditTerminationOfTreatmentPayload
    | IEditConsultationNoteMedPayload
    | IEditDocumentationRequestNoteMedPayload
    | IEditEvaluationSubmissionNoteMedPayload
    | IEditNoShowNoteMedPayload
    | IEditTermOfCareNoteMedPayload
    | IEditEvaluationManagementAndTherapyNoteMedPayload
    | IEditEvaluationManagementNoteMedPayload
    | IEditIntakeNoteMedPayload
    | IEditTreatmentReviewNoteMedPayload;

export enum NoteTypes {
    INDIVIDUAL_INTAKE_NOTE = "individual_intake_note",
    MINOR_INTAKE_NOTE = "minor_intake_note",
    FAMILY_INTAKE_NOTE = "family_intake_note",
    FAMILY_TREATMENT_REVIEW = "family_treatment_review",
    INDIVIDUAL_TREATMENT_REVIEW = "individual_treatment_review",
    INDIVIDUAL_SOAP_NOTE = "individual_soap_note",
    FAMILY_SOAP_NOTE = "family_soap_note",
    RECORD_OF_DISCLOSURE = "record_of_disclosure",
    CANCELLATION_NOTE = "cancellation_note",
    SUPERVISION_NOTE = "supervision_note",
    TERMINATION_NOTE = "termination_note",
    SAFETY_PLAN = "safety_plan",
    GENERAL_UPDATE_NOTE = "general_update_note",
    SUPERVISOR_CHECK_IN = "supervisor_check_in",
    PAUSE_NOTIFICATION_NOTE = "pause_notification_note",
    TESTING_INTAKE_MINOR_INTAKE_PSYCH = "testing_intake_minor_intake_psych",
    INTEGRATING_PATIENT_DATA_PSYCH = "integrating_patient_data_psych",
    ADMINISTRATION_PSYCH = "administration_psych",
    ADMINISTRATION_TECH = "administration_tech",
    SCORING_BY_TECH_PSYCH = "scoring_by_tech_psych",
    SCORING_BY_PSYCH = "scoring_by_psych",
    INTERPRETATION_REPORT_WRITING_PSYCH = "interpretation_report_writing_psych",
    FEEDBACK_PSYCH = "feedback_psych",
    PAUSE_NOTIFICATION_PSYCH = "pause_notification_psych",
    TERMINATION_OF_TREATMENT_PSYCH = "termination_of_treatment_psych",
    RECORD_OF_DISCLOSURE_PSYCH = "record_of_disclosure_psych",
    NO_SHOW_PSYCH = "no_show_psych",
    INITIAL_DIAGNOSTIC_EVALUATION = "initial_diagnostic_evaluation",
    INITIAL_SOAP_NOTE = "initial_soap_note",
    SUPERVISOR_DIAGNOSTIC_REVIEW = "supervisor_diagnostic_review",
    PSYCHOSOCIAL_ASSESSMENT = "psychosocial_assessment",
    MINOR_INITIAL_DIAGNOSTIC_EVALUATION = "minor_initial_diagnostic_evaluation",
    FAMILY_INITIAL_DIAGNOSTIC_EVALUATION = "family_initial_diagnostic_evaluation",
    FAMILY_INITIAL_SOAP_NOTE = "family_initial_soap_note",
    FAMILY_PSYCHOSOCIAL_ASSESSMENT = "family_psychosocial_assessment",
    MINOR_PSYCHOSOCIAL_ASSESSMENT = "minor_psychosocial_assessment",
    COMMUNICATION_WITH_CLIENT = "communication_with_client",
    FORMS_AND_DOCUMENTATION_NOTE = "forms_and_documentation_note",
    CONSULTATION_NOTE_MED = "consultation_note_med",
    DOCUMENTATION_REQUEST_NOTE_MED = "documentation_request_note_med",
    EVALUATION_MANAGEMENT_AND_THERAPY_NOTE_MED = "evaluation_management_and_therapy_note_med",
    EVALUATION_MANAGEMENT_NOTE_MED = "evaluation_management_note_med",
    EVALUATION_SUBMISSION_NOTE_MED = "evaluation_submission_note_med",
    INTAKE_NOTE_MED = "intake_note_med",
    NUTRITION_NOTE_MED = "nutrition_note_med",
    NO_SHOW_NOTE_MED = "no_show_note_med",
    TERM_OF_CARE_NOTE_MED = "term_of_care_note_med",
    TREATMENT_REVIEW_NOTE_MED = "treatment_review_note_med",
}

interface INoteLabels {
    [key: string]: string;
}

export const NoteLabels: INoteLabels = {
    individual_intake_note: "Individual intake note",
    family_intake_note: "Family intake note",
    // Leaving this for old notes currently on the app
    treatment_review: "Individual treatment review",
    individual_treatment_review: "Individual treatment review",
    family_treatment_review: "Family treatment review",
    individual_soap_note: "Individual soap note",
    family_soap_note: "Family soap note",
    record_of_disclosure: "Record of disclosure",
    cancellation_note: "No show/late cancel",
    supervision_note: "Supervision note",
    termination_note: "Termination note",
    safety_plan: "Safety plan",
    general_update_note: "General update note",
    supervisor_check_in: "Supervisor check-in note",
    minor_intake_note: "Minor intake note",
    pause_notification_note: "Pause notification note",
    testing_intake_minor_intake_psych: "Testing intake/minor intake (psych)",
    integrating_patient_data_psych: "Integrating patient data (psych)",
    administration_psych: "Administration by psych (psych)",
    administration_tech: "Administration by tech (psych)",
    scoring_by_tech_psych: "Scoring by tech (psych)",
    scoring_by_psych: "Scoring by psych (psych)",
    interpretation_report_writing_psych:
        "Interpretation report writing (psych)",
    feedback_psych: "Feedback note (psych)",
    pause_notification_psych: "Pause notification note (psych)",
    termination_of_treatment_psych: "Termination of treatment (psych)",
    record_of_disclosure_psych: "Record of disclosure (psych)",
    no_show_psych: "No show note (psych)",
    initial_diagnostic_evaluation: "Initial diagnostic evaluation",
    initial_soap_note: "Initial soap note",
    supervisor_diagnostic_review: "Supervisor diagnostic review",
    psychosocial_assessment: "Psychosocial assessment",
    minor_initial_diagnostic_evaluation: "Minor initial diagnostic evaluation",
    family_initial_diagnostic_evaluation:
        "Family initial diagnostic evaluation",
    family_initial_soap_note: "Family initial soap note",
    family_psychosocial_assessment: "Family psychosocial assessment",
    minor_psychosocial_assessment: "Minor psychosocial assessment",
    communication_with_client: "Communication with client (psych)",
    forms_and_documentation_note: "Forms & documentation note",
    consultation_note_med: "Consultation note (med)",
    documentation_request_note_med: "Documentation request note (med)",
    evaluation_management_and_therapy_note_med:
        "Evaluation management and therapy note (med)",
    evaluation_management_note_med: "Evaluation management note (med)",
    evaluation_submission_note_med: "Evaluation submission note (med)",
    intake_note_med: "Intake note (med)",
    nutrition_note_med: "Nutrition note (med)",
    no_show_note_med: "No show note (med)",
    term_of_care_note_med: "Term of care note (med)",
    treatment_review_note_med: "Treatment review note (med)",
};

export enum Source {
    ELECTRONIC = "Electronic",
    MANUAL = "Manual",
}

export enum ModifierTypes {
    PROLONGED_EVALUATION_AND_MANAGEMENT = "21 Prolonged Evaluation & Management",
    UNUSUAL_PROCEDURAL_SERVICES = "22 Unusual Procedural Services",
    UNRELATED_EVALUATION_AND_MANAGEMENT = "24 Unrelated Evaluation & Management",
    IDENTIFIABLE_EVALUATION_AND_MANAGEMENT_SERVICE = "25 Significant, Separately Identifiable Evaluation and Management Service by the Same Physician on the Same Day of the Procedure or Other Service",
    DISTINCT_PROCEDURAL_SERVICE = "59 Distinct Procedural Service",
    TELEMEDICINE_AUDIO_ONLY = "93 Telemedicine (Audio only)",
    TELEMEDICINE = "95 Telemedicine",
    MULTIPLE_MODIFIERS = "99 Multiple Modifiers",
    TELEHEALTH = "GT Telehealth",
}

export enum NoteStatus {
    CODED = "coded",
    DRAFT = "draft",
    PENDING_SUPERVISOR_REVIEW = "pending_supervisor_review",
    CHANGES_REQUESTED = "changes_requested",
    PENDING_CODE_REVIEW = "pending_code_review",
}

export enum MethodOfDisclosure {
    FAX = "Fax",
    TELEPHONE = "Telephone",
    ELECTRONIC = "Electronic",
    MAIL = "Mail",
    OTHER = "Other",
}

export const CPT_CODES = [
    "90847",
    "99449",
    "90837",
    "90834",
    "90846",
    "90832",
    "90791",
    "99448",
    "90785",
];

export enum SessionServiceType {
    CHILD_THERAPY = "child_therapy",
    FAMILY_THERAPY = "family_therapy",
    INDIVIDUAL_THERAPY = "individual_therapy",
    INTUITIVE_EATING = "intuitive_eating",
    MEDICATION_MANAGEMENT = "medication_management",
    PSYCHIATRIC_COUNSELING = "psychiatric_counseling",
    MENTAL_HEALTH_ASSESSMENT = "mental_health_assessment",
    GIFTED_ASSESSMENT = "gifted_assessment",
    SHORT_TERM_EVALUATION_DOCUMENTATION = "short_term_evaluation_documentation",
    TELETHERAPY = "teletherapy",
}

export enum NoteCategory {
    THERAPY = "therapy",
    TESTING = "testing",
}

interface INoteCategoryLabels {
    [key: string]: string;
}

export const NoteCategoryLabels: INoteCategoryLabels = {
    therapy: "Therapy",
    testing: "Pysch",
};

export const noteTypesForExport = [
    NoteTypes.INITIAL_SOAP_NOTE,
    NoteTypes.FAMILY_INITIAL_SOAP_NOTE,
    NoteTypes.INDIVIDUAL_SOAP_NOTE,
    NoteTypes.INDIVIDUAL_INTAKE_NOTE,
    NoteTypes.FAMILY_INTAKE_NOTE,
    NoteTypes.SAFETY_PLAN,
    NoteTypes.INDIVIDUAL_TREATMENT_REVIEW,
    NoteTypes.FAMILY_TREATMENT_REVIEW,
    NoteTypes.FAMILY_SOAP_NOTE,
];

export const BILLABLE_THERAPY_NOTE_TYPES = [
    NoteTypes.INDIVIDUAL_INTAKE_NOTE,
    NoteTypes.FAMILY_INTAKE_NOTE,
    NoteTypes.MINOR_INTAKE_NOTE,
    NoteTypes.INDIVIDUAL_SOAP_NOTE,
    NoteTypes.FAMILY_SOAP_NOTE,
    NoteTypes.INITIAL_SOAP_NOTE,
    NoteTypes.FAMILY_INITIAL_SOAP_NOTE,
    NoteTypes.INDIVIDUAL_TREATMENT_REVIEW,
    NoteTypes.FAMILY_TREATMENT_REVIEW,
    NoteTypes.TERMINATION_NOTE,
    NoteTypes.RECORD_OF_DISCLOSURE,
    NoteTypes.INITIAL_DIAGNOSTIC_EVALUATION,
    NoteTypes.FAMILY_INITIAL_DIAGNOSTIC_EVALUATION,
    NoteTypes.MINOR_INITIAL_DIAGNOSTIC_EVALUATION,
].sort((a, b) => a.localeCompare(b));

export const BILLABLE_PSYCHIATRY_NOTE_TYPES = [
    NoteTypes.TESTING_INTAKE_MINOR_INTAKE_PSYCH,
    NoteTypes.INTEGRATING_PATIENT_DATA_PSYCH,
    NoteTypes.ADMINISTRATION_PSYCH,
    NoteTypes.ADMINISTRATION_TECH,
    NoteTypes.SCORING_BY_TECH_PSYCH,
    NoteTypes.SCORING_BY_PSYCH,
    NoteTypes.INTERPRETATION_REPORT_WRITING_PSYCH,
    NoteTypes.FEEDBACK_PSYCH,
].sort((a, b) => a.localeCompare(b));

export const ALL_BILLABLE_NOTE_TYPES = [
    ...BILLABLE_THERAPY_NOTE_TYPES,
    ...BILLABLE_PSYCHIATRY_NOTE_TYPES,
];

export interface INoteContentDetails {
    first_session_date: string;
    last_session_date: string;
    no_of_sessions: string;
    patient_final_condition: string;
    prognosis: string;
    note_contents: INoteContent[];
}

export interface INoteUnitCalculation {
    duration: number;
    total_units: number;
    minutes_per_unit: number;
    unit_assignments: {
        unit: string;
        cpt_code: string;
    }[];
}

export interface IRecalculateUnitMetadataPayload {
    note_ids: string[];
    dry_run: boolean;
}

export interface IRecalculateUnitMetadataResult {
    note_id: string;
    unit_calculation?: INoteUnitCalculation;
    dry_run: boolean;
    error?: string;
}

export interface INote {
    additional_cpt_codes?: string[] | null;
    note_id: string;
    insurance_provider_id?: string;
    provider?: {
        first_name: string;
        last_name: string;
        user_id?: string;
    };
    date_of_service: string;
    note_type: NoteTypes;
    note_url?: string;
    client: {
        client_id: string;
        first_name: string;
        last_name: string;
        insurance_provider_name?: string;
        self_pay?: boolean;
    };
    cpt_code: string;
    status: NoteStatus;
    modifier_codes?: string[];
    is_archived?: boolean;
    session_history_id: string;
    appointment_type: SessionServiceType;
    created_at: string;
    author: {
        id: string;
        first_name: string;
        last_name: string;
    };
    external_reference_id?: string;
    flagged_for_audit_status?: FlaggedNoteForAuditStatus;
    note_metadata?: {
        unit_calculation: INoteUnitCalculation;
    };
    claim_id?: string;
}

export interface INoteDetails {
    note_id?: string;
    note_type: NoteTypes;
    note_status?: NoteStatus;
    note_provider?: string;
    dates_of_service?: string;
    client?: {
        client_id?: string;
        first_name?: string;
        last_name?: string;
        insurance_provider_name?: "cigna";
        self_pay?: boolean;
    };
    start_time?: string;
    end_time?: string;
    duration?: string;
    appointment_type?: SessionServiceType;
    provider_signature?: string;
    date_added?: string;
    time_added?: string;
    provider?: {
        first_name: string;
        last_name: string;
    };
    is_archived?: boolean;
}

export interface ISuperviseeNote {
    note_id: string;
    date_of_service: string;
    note_type: NoteTypes;
    supervisee_name: string;
    cpt_code: string;
    additional_cpt_codes?: string[] | null;
    status: NoteStatus;
    provider: {
        first_name: string;
        last_name: string;
        user_id: string;
    };
    client: {
        client_id: string;
        first_name: string;
        last_name: string;
        insurance_provider_name?: string;
        self_pay?: boolean;
    };
    is_archived?: boolean;
    session_history_id: string;
    appointment_type: SessionServiceType;
    created_at: string;
    author: {
        id: string;
        first_name: string;
        last_name: string;
    };
    external_reference_id?: string;
    note_metadata?: {
        unit_calculation: INoteUnitCalculation;
    };
    claim_id?: string;
}

export interface IAddendumDetails {
    note_id: string;
    note_addendum_id?: string;
    author: {
        first_name: string;
        last_name: string;
        email: string;
    };
    signature: string;
    signature_date_time: string;
    title: string;
    content: string;
    field_id: string | null;
    field_title: string | null;
}

export interface INotesListFilterTypes {
    client_name?: string;
    status?: string[];
    type?: string[];
    cpt_code?: string;
    from_date?: null | Date;
    to_date?: null | Date;
    page?: number;
    provider_name?: string;
    limit?: number;
    show_archived?: string;
    sort_attribute?: string;
    sort_order?: string;
    client_id?: string;
    insurance_provider_id?: string;
    insurance_provider_ids?: string[];
    is_flagged_for_audit?: boolean;
    show_notes_eligible_for_bulk_claim?: boolean | "true" | "false";
}

export interface ISuperviseeNotesListFilters {
    provider_name: string;
    cpt_code?: string;
    type: string[];
    from_date: null | Date;
    to_date: null | Date;
    page: number;
    status: string[];
    limit: number;
    show_archived?: string;
}
export interface IGetMessages {
    message_id: string;
    message: string;
    sender_user_id: string;
    sender_first_name: string;
    sender_last_name: string;
    is_public: boolean;
    sent_time: string;
    recipient_user_id: string;
    recipient_first_name: string;
    recipient_last_name: string;
}

export interface IAppointmentDetails {
    client_name: string;
    date_of_service: string;
    note_type: string;
    appointment_type?: string;
    start_time?: string;
    provider_name?: string;
    provider_signature?: string;
    duration?: string;
    end_time?: string;
}

export interface IChangeCodeResponse {
    cpt_code: string;
    modifier_codes: string[];
    note_id: string;
    pos_code: string;
    status: string;
}

export type SupervisorChainHopReason =
    | "default_supervisor"
    | "category_override"
    | "insurance_override";

export interface SupervisorChainActivityHop {
    provider_id: string;
    name: string;
    reason: SupervisorChainHopReason;
}

export interface IActivity extends ISortTable {
    note_activity_id: string;
    activity_datetime: string;
    activity_user: {
        id: string;
        first_name: string;
        last_name: string;
    };
    activity_description: string;
    metadata?: {
        addendum_field_id?: string;
        flag_for_audit_notes?: string;
        supervisor_name?: string;
        chain?: SupervisorChainActivityHop[];
    };
}

export interface INoteActivities {
    note_activities: IActivity[];
}

export interface IChangeCode {
    [noteId: string]: {
        cpt_code: string;
        modifier_codes?: string[];
        pos_code?: string;
        confirm_code?: boolean;
        unit_calculation?: {
            duration: number;
            total_units: number;
            minutes_per_unit: number;
            unit_assignments: {
                unit: number;
                cpt_code: string;
            }[];
        };
    };
}

export interface IDeleteNoteMessage {
    message_id: string;
}
export interface IDeleteNoteMessageResponse {
    deleted: boolean;
}

export interface ClientNoteParams {
    type: string | string[];
    load_previous_notes: boolean;
    provider_id: string;
    before_date?: string;
    limit?: number;
    status?: NoteStatus[];
}

export interface IAddNoteMessage {
    message: string;
    is_public: boolean;
    recipient_user_id?: string;
}
export interface IAddNoteMessageResponse {
    message_id: string;
    message: string;
    sender_user_id: string;
    sender_first_name: string;
    sender_last_name: string;
    is_public: boolean;
    sent_time: string;
}

export interface INotesFilterTypes {
    search_string?: string;
    note_ids?: string[];
    status?: string[];
    type?: string[];
    cpt_code?: string;
    from_date?: null | string;
    to_date?: null | string;
    page?: number;
    provider_name?: string;
    limit?: number;
    show_archived?: string;
    sort_attribute?: string;
    sort_order?: string;
    client_id?: string;
    insurance_provider_ids?: string[];
    author_id?: string;
    is_flagged_for_audit?: string;
    tab_name?: string;
    from_created_at_date?: null | string;
    to_created_at_date?: null | string;
    flagged_for_audit_status?: string[];
    provider_id?: string;
    show_notes_without_claims?: boolean | "true" | "false";
    show_notes_eligible_for_bulk_claim?: boolean | "true" | "false";
}

export interface IGetClientNotes {
    note_id: string;
    archived_notes: string;
    is_archived: boolean;
    note_content: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [key: string]: any;
    };
    provider: {
        provider_id: string;
        first_name: string;
        last_name: string;
    };
    client: {
        client_id: string;
        first_name: string;
        last_name: string;
    };
    note_type: string;
    appointment_type: string;
    note_url: string;
    cpt_code: string;
    status: string;
    date_of_service: string;
    modifier_codes: string[];
}

export interface INoteAuditDashboardList {
    date_of_service: string;
    overdue_period_secs: number;
    session_service: SessionServiceType;
    note_status: NoteStatus;
    note_id: string;
    provider: {
        id: string;
        first_name: string;
        last_name: string;
        credential: string;
    };
    supervisor: {
        id: string;
        first_name: string;
        last_name: string;
    };
    client: {
        id: string;
        first_name: string;
        last_name: string;
    };
    author: {
        id: string;
        first_name: string;
        last_name: string;
    };
}

export interface INewNoteAppoinmentDetails {
    note_type: NoteTypes;
    client_name: string;
    appointment_type?: SessionServiceType;
    session_history_id: string | null;
    date_of_service?: string | null;
    session_start_time: string | null;
    session_end_time: string | null;
    provider_name?: string;
    session_id: string;
    client_id: string;
    duration?: string;
    provider_signature?: string;
    provider_signature_datetime?: string;
    supervisor_name?: string;
    supervisor_signature?: string;
    supervisor_signature_datetime?: string;
    provider_id: string;
    first_session_date: string | null;
    no_of_sessions?: number | null;
    modifier_codes?: string[];
    reason_for_short_duration?: string;
}

export interface INoteAuditDashboardResponse {
    from_date: string;
    to_date: string;
    summary: {
        overdue_notes_count: number;
        average_time_to_sign_note_secs: number;
        average_time_to_complete_first_review_secs: number;
    };
    overdue_notes: INoteAuditDashboardList[];
}

export enum ChangeRequestSource {
    AUDIT = "audit",
    SUPERVISOR = "supervisor",
    BILLING = "billing",
}

export enum ChangeRequestStatus {
    OPEN = "open",
    ANSWERED = "answered",
    CLOSED = "closed",
}

export enum ChangeRequestOutcome {
    CLINICIAN_CORRECTED = "clinician_corrected",
    FLAGGED_IN_ERROR = "flagged_in_error",
}

export interface IChangeRequestOutcomePayload {
    outcome: ChangeRequestOutcome;
    comment?: string;
}

export interface IRequestDetails {
    request_id: string;
    request_details: string;
    request_reason: string;
    source: ChangeRequestSource | null;
    status: ChangeRequestStatus;
    answered_at: string | null;
    closed_at: string | null;
    outcome: ChangeRequestOutcome | null;
    outcome_comment: string | null;
    can_update_outcome: boolean;
    request_datetime: string;
    requester: {
        id: string;
        first_name: string;
        last_name: string;
    };
}

export interface IFlagNote {
    note_ids_to_flag_for_audit: string[];
    flag_for_audit_status: string;
    flag_for_audit_notes?: string;
}

export enum FlaggedNoteForAuditStatus {
    FLAGGED = "flagged",
    SENT_FOR_CHANGES = "sent_for_changes",
    REQUIRES_ACTION = "requires_action",
    UNFLAGGED = "unflagged",
}

export enum TypeOfDisclosure {
    TREATMENT_RECORD = "Treatment Record",
    PAYMENT_INFORMATION = "Payment Information",
    HEALTHCARE_OPERATION = "Healthcare Operation",
}

export enum NoteListSortAttribute {
    DATE_OF_SERVICE = "date_of_service",
    CLIENT_NAME = "client_name",
    PROVIDER_NAME = "provider_name",
}

export interface INoteContent {
    id: string;
    header: string;
    body: string;
}

export interface IClientNoteWithDos {
    note_id: string;
    note_url: string;
    type: NoteTypes;
    source: string;
    created_at: string;
    date_of_service: string;
    provider: {
        provider_id: string;
        first_name: string;
        last_name: string;
    };
}

export type IEditNoteAppointmentDetails = INewNoteAppoinmentDetails;

export type CreateNoteSteps = "appointment-details" | "add-note";

export type EditNoteSteps = "appointment-details" | "edit-note";

export interface ISupervisionFormValues {
    supervision_note: string;
    client_note: string;
}

export interface ICancellationFormValues {
    reason: string;
}

export interface IRecordOfDisclosureFormValues {
    duration: string;
    diagnosis: string;
    disclosure_to_whom: string;
    disclosure_type: string;
    purpose_of_disclosure: string;
    type_disclosed: string;
    method_of_disclosure: string;
    session_start_time: string;
    session_end_time: string;
}

export type NoteContent<T> = T;
export interface ISessionNote {
    note_id: string;
    note_status: NoteStatus;
    note_last_modified_at?: string;
    type: NoteTypes;
    pos_code?: string;
    client: {
        client_id: string;
        first_name: string;
        last_name: string;
        date_of_birth?: string;
        age?: string;
        contact?: string;
        pronouns?: string;
        email?: string;
        sex?: string;
        self_pay?: boolean;
    };
    claim_id?: string;
    appointment_type: SessionServiceType;
    session_id: string;
    provider: {
        provider_id: string;
        first_name: string;
        last_name: string;
        supervisor_id?: string;
    };
    session_history_id: string;
    date_of_service: string;
    session_start_time: string;
    session_end_time: string;
    invoice_status?: string;
    invoice_id?: string;
    note_content: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [key: string]: any;
    };
    note_signatures: {
        provider_id: string;
        signature_date_time: string;
        role: string;
        first_name: string;
        last_name: string;
        signature: string;
    }[];
    cpt_code?: string;
    additional_cpt_codes?: string[];
    note_url?: string;
    delivery_option?: SessionDeliveryOption;
    modifier_codes?: string[];
    reason?: string;
    insurance_provider?: string;
    issue_category?: string;
    issue_notes?: string;
    is_archived?: boolean;
    archive_notes?: string;
    is_flagged_for_audit?: boolean;
    flagged_for_audit_notes?: string;
    reason_for_short_duration?: string;
    note_addendums: {
        field_addendums: {
            [key: string]: IAddendumDetails[];
        } | null;
        general_addendums: IAddendumDetails[] | null;
    };
    source?: Source;
    note_url_metadata?: {
        content_type: string;
    };
    manual_note_diagnosis_codes?: { label: string; code: string }[];
    flagged_for_audit_status?: FlaggedNoteForAuditStatus;
    is_eligible_for_claim_creation?: boolean;
    can_resolve_change_request?: boolean;
    note_content_documents?: INoteDocument[];
    note_metadata?: {
        unit_calculation?: INoteUnitCalculation;
    };
}

export interface INewSessionNote {
    client_id: string;
    session_id: string;
    provider_id: string;
    session_history_id: string | null;
    date_of_service: string | null;
    session_start_time?: string;
    session_end_time?: string;
    appointment_type: SessionServiceType;
    pos_code?: string;
    note_content: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [key: string]: any;
    };
    note_type: string;
    diagnosis_codes?: string[];
    cancelled_by?: string;
    reason_for_short_duration?: string;
}

export interface ISignNewNotePayload {
    signature: string;
    signature_date_time: string;
}

export interface IApproveNotePayload {
    note_ids: string[];
    signature: string;
    signature_date_time: string;
}

export interface IApproveNoteResponse {
    message: string;
    data: {
        approved_notes: {
            note_id: string;
            status: NoteStatus;
            cpt_code: string;
        }[];
        unapproved_notes: string[];
    };
}

export interface IRequestChangePayload {
    request_reason: string;
    request_details: string;
    other_reason?: string;
    source: ChangeRequestSource;
}

export interface INewNoteResponse {
    client_id?: string;
    note_id: string;
    note_status: NoteStatus;
}

export interface IExportNotePayload {
    session_note_ids: string[];
}

export interface IChangeArchiveStatus {
    note_ids_to_archive: string[];
    archive_status: boolean;
    reason?: string;
}

export interface ITerminateIntakeAppointmentForNotePayload {
    intakeClientId: string;
    externalSessionId: string;
    payload: {
        reason: string;
        caller_role: "admin" | "clinician";
        updated_by: string;
        notes: string;
        termination_message_requested: boolean;
        reason_for_termination_msg_skip?: string;
    };
}

// SOAP NOTE
export type SoapSteps = "one" | "two" | "three" | "four";

export enum SoapProgressSteps {
    STEP_ONE = "step_one",
    STEP_TWO = "step_two",
    STEP_THREE = "step_three",
    STEP_FOUR = "step_four",
}
export interface ISoapFormValues {
    duration?: string;
    isClientPresent?: boolean;
    appointment_location?: string;
    delivery_option?: string;
    other_delivery_option?: string;
    diagnosis_codes?: string[];
    emotional_behavioural_symptoms_demonstrated?: string;
    causing?: string;
    intention_for_session?: string;
    subjective?: string;
    objective?: string;
    assessment?: string;
    cognitive_behavioral_therapies?: string[];
    relationship_based_interventions?: string[];
    other?: string[];
    plan?: string;
    prognosis?: string;
    client_response?: string;
    goal_one?: string;
    goal_two?: string;
    goal_three?: string;
    progress_one?: string;
    progress_two?: string;
    progress_three?: string;
}

export interface INewAddendumForm {
    title: string;
    content: string;
    field_id: string;
    field_title: string;
    signature: string;
    signature_datetime: string;
}

export type INewAddendum = INewAddendumForm[];

export interface IEditDraftNote {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    note_content?: { [key: string]: any };
    date_of_service?: string | null;
    session_start_time?: string;
    session_end_time?: string;
    pos_code?: string;
    reason_for_short_duration?: string;
    expected_note_last_modified_at?: string | null;
    appointment_type?: string;
    // adding this for form logic, will remove before submitting
    note_type?: string;
}

export interface FamilyIntakeNotePayload {
    name: string;
    gender: string;
    other_gender: string;
    preferred_name: string;
    pronouns: string;
    other_sexual_orientation: string;
    religion: string;
    education: string;
    race: string;
    ethinicity: string;
    sexual_orientation: string;
    current_employment: string;
    current_employment_details: string;
    relationship_status: string;
    name_of_partner: string;
    emergency_contact_information: string;
    legal_problems: string;
    anxiety_frequency: string;
    anxiety_details: string;
    panic_attacks_freqency: string;
    panic_attacks_details: string;
    depression_freqency: string;
    depression_details: string;
    selected_symptoms: string[];
    other_symptoms: string;
    physical_symptoms: string;
    medication_physical_psychiatric: string;
    sleeping_habits_and_concerns: string;
    difficulties_with_appetite_or_eating_patterns: string;
    parents_stepparents_history: string;
    siblings_history: string;
    grandparents_history: string;
    children_history: string;
    other_family_members_history: string;
    family_members_alcohol_abuse: string[];
    family_members_alcohol_abuse_other: string;
    family_members_anxiety: string[];
    family_members_anxiety_other: string;
    family_members_bipolar_disorder: string[];
    family_members_bipolar_disorder_other: string;
    family_members_depression: string[];
    family_members_depression_other: string;
    family_members_ptsd: string[];
    family_members_ptsd_other: string;
    family_members_schizophrenia: string[];
    family_members_schizophrenia_other: string;
    family_members_substance_abuse: string[];
    family_members_substance_abuse_other: string;
    family_members_substance_abuse_substance: string;
    trauma_abuse_history: string;
    previous_mental_health_treatment_oupatient: string;
    impatient_psychiatric_hospitalization: string;
    relevant_medical_history: string;
    been_so_distressed_you_seriously_wished_to_end_your_life: string;
    describe_been_so_distressed_you_seriously_wished_to_end_your_life?: string;
    has_anything_happened_recently_to_make_you_feel_you_dont_want_to_live: string;
    describe_has_anything_happened_recently_to_make_you_feel_you_dont_want_to_live?: string;
    a_specific_plan_of_how_you_would_kill_yourself: string;
    describe_a_specific_plan_of_how_you_would_kill_yourself?: string;
    access_to_weapons_or_means_of_hurting_self: string;
    describe_access_to_weapons_or_means_of_hurting_self?: string;
    made_serious_suicide_attempts: string;
    describe_made_serious_suicide_attempts?: string;
    purposely_done_something_to_hurt_yourself: string;
    describe_done_something_to_hurt_yourself?: string;
    heard_voices_telling_you_to_hurt_yourself: string;
    describe_heard_voices_telling_you_to_hurt_yourself?: string;
    had_relatives_who_attempted_or_commited_sucide: string;
    describe_had_relatives_who_attempted_or_commited_sucide?: string;
    had_thoughts_of_killing_or_seriously_hurting_someone: string;
    describe_had_thoughts_of_killing_or_seriously_hurting_someone?: string;
    heard_voices_telling_you_to_hurt_others: string;
    describe_heard_voices_telling_you_to_hurt_others?: string;
    hurt_someone_or_destroyed_property_on_purpose: string;
    describe_hurt_someone_or_destroyed_property_on_purpose?: string;
    slapped_kicked_punched_someone_with_intent_to_harm: string;
    describe_slapped_kicked_punched_someone_with_intent_to_harm?: string;
    been_arrested_or_detained_for_violent_behavior: string;
    describe_been_arrested_or_detained_for_violent_behavior?: string;
    been_to_jail_for_any_reason: string;
    describe_been_to_jail_for_any_reason?: string;
    been_on_probation_for_any_reason: string;
    describe_been_on_probation_for_any_reason?: string;
    do_you_have_access_to_guns: string;
    describe_do_you_have_access_to_guns?: string;
    mental_health_appearance: string[];
    mental_health_movement: string[];
    mental_health_speech_behaviour: string[];
    mental_health_affect_mood: string[];
    mental_health_attention_concentration_effort: string[];
    mental_health_presentation_of_self: string[];
    mental_health_cognition: string[];
    patients_ability_and_capability_to_respond_to_treatment: string[];
    details_for_diminished_poor_limited_quality_patient_oriented_evidence: string;
    anxiety?: boolean;
    panic_attacks?: boolean;
    depression?: boolean;
    family_id?: string;
}

export const emptyFamilyIntakeNote: FamilyIntakeNotePayload = {
    name: "",
    gender: "",
    other_gender: "",
    preferred_name: "",
    pronouns: "",
    other_sexual_orientation: "",
    religion: "",
    education: "",
    race: "",
    ethinicity: "",
    sexual_orientation: "",
    current_employment: "",
    current_employment_details: "",
    relationship_status: "",
    name_of_partner: "",
    emergency_contact_information: "",
    legal_problems: "",
    anxiety_frequency: "",
    anxiety_details: "",
    panic_attacks_freqency: "",
    panic_attacks_details: "",
    depression_freqency: "",
    depression_details: "",
    selected_symptoms: [],
    other_symptoms: "",
    physical_symptoms: "",
    medication_physical_psychiatric: "",
    sleeping_habits_and_concerns: "",
    difficulties_with_appetite_or_eating_patterns: "",
    parents_stepparents_history: "",
    siblings_history: "",
    grandparents_history: "",
    children_history: "",
    other_family_members_history: "",
    family_members_alcohol_abuse: [],
    family_members_alcohol_abuse_other: "",
    family_members_anxiety: [],
    family_members_anxiety_other: "",
    family_members_bipolar_disorder: [],
    family_members_bipolar_disorder_other: "",
    family_members_depression: [],
    family_members_depression_other: "",
    family_members_ptsd: [],
    family_members_ptsd_other: "",
    family_members_schizophrenia: [],
    family_members_schizophrenia_other: "",
    family_members_substance_abuse: [],
    family_members_substance_abuse_other: "",
    family_members_substance_abuse_substance: "",
    trauma_abuse_history: "",
    previous_mental_health_treatment_oupatient: "",
    impatient_psychiatric_hospitalization: "",
    relevant_medical_history: "",
    been_so_distressed_you_seriously_wished_to_end_your_life: "",
    describe_been_so_distressed_you_seriously_wished_to_end_your_life: "",
    has_anything_happened_recently_to_make_you_feel_you_dont_want_to_live: "",
    describe_has_anything_happened_recently_to_make_you_feel_you_dont_want_to_live:
        "",
    a_specific_plan_of_how_you_would_kill_yourself: "",
    describe_a_specific_plan_of_how_you_would_kill_yourself: "",
    access_to_weapons_or_means_of_hurting_self: "",
    describe_access_to_weapons_or_means_of_hurting_self: "",
    made_serious_suicide_attempts: "",
    describe_made_serious_suicide_attempts: "",
    purposely_done_something_to_hurt_yourself: "",
    describe_done_something_to_hurt_yourself: "",
    heard_voices_telling_you_to_hurt_yourself: "",
    describe_heard_voices_telling_you_to_hurt_yourself: "",
    had_relatives_who_attempted_or_commited_sucide: "",
    describe_had_relatives_who_attempted_or_commited_sucide: "",
    had_thoughts_of_killing_or_seriously_hurting_someone: "",
    describe_had_thoughts_of_killing_or_seriously_hurting_someone: "",
    heard_voices_telling_you_to_hurt_others: "",
    describe_heard_voices_telling_you_to_hurt_others: "",
    hurt_someone_or_destroyed_property_on_purpose: "",
    describe_hurt_someone_or_destroyed_property_on_purpose: "",
    slapped_kicked_punched_someone_with_intent_to_harm: "",
    describe_slapped_kicked_punched_someone_with_intent_to_harm: "",
    been_arrested_or_detained_for_violent_behavior: "",
    describe_been_arrested_or_detained_for_violent_behavior: "",
    been_to_jail_for_any_reason: "",
    describe_been_to_jail_for_any_reason: "",
    been_on_probation_for_any_reason: "",
    describe_been_on_probation_for_any_reason: "",
    do_you_have_access_to_guns: "",
    describe_do_you_have_access_to_guns: "",
    mental_health_appearance: [],
    mental_health_movement: [],
    mental_health_speech_behaviour: [],
    mental_health_affect_mood: [],
    mental_health_attention_concentration_effort: [],
    mental_health_presentation_of_self: [],
    mental_health_cognition: [],
    patients_ability_and_capability_to_respond_to_treatment: [],
    details_for_diminished_poor_limited_quality_patient_oriented_evidence: "",
    anxiety: false,
    panic_attacks: false,
    depression: false,
};

export interface INoteAuditDahboardResponse {
    from_date: string;
    to_date: string;
    summary: {
        overdue_notes_count: number;
        average_time_to_sign_note_secs: number;
        average_time_to_complete_first_review_secs: number;
    };
    overdue_notes: INoteAuditDashboardList[];
}

export type AiSessionNoteType =
    | NoteTypes.INDIVIDUAL_SOAP_NOTE
    | NoteTypes.FAMILY_SOAP_NOTE
    | NoteTypes.INITIAL_SOAP_NOTE
    | NoteTypes.FAMILY_INITIAL_SOAP_NOTE;

export interface IAiSessionNoteWriterContext {
    diagnosis_codes: string[];
    goal_one?: string;
    goal_two?: string;
    goal_three?: string;
    risk_and_safety_language?: string;
    new_risk_concerns_details?: string;
    additional_client_reported_information_post_intake?: string;
    continuity_context?: {
        source_note_id: string;
        previous_note_date: string;
        recent_goal_progress: Array<{
            goal_id: "goal_one" | "goal_two" | "goal_three";
            goal: string;
            progress: string;
        }>;
    };
}

export interface IAiSessionNoteDraftRequest {
    session_synopsis: string;
    note_context: IAiSessionNoteWriterContext;
}

export interface IAiSessionNoteDraft {
    note_type: AiSessionNoteType;
    note_content: Record<string, string | string[]>;
    diagnosis_suggestion?: {
        code: string;
        description: string;
        rationale: string;
    };
    requires_human_review: true;
    human_review_reasons: string[];
}

export type AiSessionNoteReviewStatus =
    | "adequate"
    | "needs_improvement"
    | "missing"
    | "not_applicable";

export interface IAiSessionNoteFieldReview {
    score: number | null;
    status: AiSessionNoteReviewStatus;
    findings: string[];
    suggestions: string[];
}

export interface IAiSessionNoteGoalReview {
    goal_id: "goal_one" | "goal_two" | "goal_three";
    goal: IAiSessionNoteFieldReview;
    progress: IAiSessionNoteFieldReview;
}

export interface IAiSessionNoteReview {
    note_type: AiSessionNoteType;
    field_reviews: Record<string, IAiSessionNoteFieldReview>;
    goal_reviews: IAiSessionNoteGoalReview[];
    initial_field_reviews?: Record<string, IAiSessionNoteFieldReview>;
    overall_assessment: {
        score: number;
        summary: string;
        strengths: string[];
        concerns: string[];
        category_scores: Record<string, number>;
    };
    suggested_improvements: Array<{
        field: string;
        priority: "high" | "medium" | "low";
        recommendation: string;
        rationale: string;
    }>;
    missing_information: Array<{
        field: string;
        detail: string;
        impact: string;
    }>;
    inconsistent_information: Array<{
        fields: string[];
        detail: string;
        resolution_needed: string;
    }>;
    requires_human_review: boolean;
    human_review_reasons: string[];
}

export interface INoteDocument {
    note_content_document_id: string;
    note_id: string;
    client_id: string;
    url: string;
    created_at: string;
    third_party_id: string | null;
    third_party_type: string | null;
    document_name: string | null;
    metadata: {
        content_type: string;
    };
    uploaded_by: {
        first_name: string;
        last_name: string;
        user_id: string;
    };
}

export interface IDeleteNoteContentDocument {
    document_ids: string[];
}

export const Modality = {
    Individual: "individual",
    Family: "family",
    Family_With_Ip: "family_with_ip",
} as const;

export const ConditionType = {
    Chronic: "chronic",
    Acute: "acute",
} as const;

export const ConditionStatus = {
    At_Treatment_Goal: "at_treatment_goal",
    Stable: "stable",
    Worsening: "worsening",
    Active_Treatment: "active_treatment",
} as const;

export const SessionLocations = {
    In_Person: "in_person",
    Telehealth: "telehealth",
} as const;

export const ClientLocations = {
    Home: "home",
    Office: "office",
    Other: "other",
};

export const ProviderLocations = {
    Home: "home",
    Office: "office",
    Other: "other",
};

export type ModalityTypes = typeof Modality[keyof typeof Modality];
export type ConditionTypes = typeof ConditionType[keyof typeof ConditionType];
export type ConditionStatusTypes =
    typeof ConditionStatus[keyof typeof ConditionStatus];
export type SessionLocationTypes =
    typeof SessionLocations[keyof typeof SessionLocations];
export type ClientLocationTypes =
    typeof ClientLocations[keyof typeof ClientLocations];
export type ProviderLocationTypes =
    typeof ProviderLocations[keyof typeof ProviderLocations];

export interface ScreeningQuestion {
    id: string;
    label: string;
    options: readonly string[];
    required?: boolean;
    showNumber?: boolean;
}

export interface ScreeningSection {
    title?: string;
    description?: string;
    questions: ScreeningQuestion[];
}

export interface ScreeningTool {
    id: string;
    title: string;
    description: string;
    sections: ScreeningSection[];
}

export interface ScreeningResult {
    score?: number;
    maximumScore?: number;
    interpretation: string;
    detail?: string;
}
